import React from "react";
import { Link } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';
import { rndLogoInstance, burgerMenuInstance, closeBurgerMenuInstance } from '@components/Globals';


import styles from './navigation.module.css';
import mobileNavigationBar from './MobileNavigationBar.jsx';

function NavigationBar(props) {
  return (
    <>
      <BrowserView>
        <div>
          <nav className={styles.nav}>
            <label htmlFor="nav__checkbox" className={styles.nav__toggle}>
              <img src={burgerMenuInstance} className={styles.hamburger} alt="" />
              <img src={closeBurgerMenuInstance} className={styles.close} alt="" />
            </label>

            <ul className={styles.nav__menu} >
              <li>
                <Link className={styles.link} to='/'><img src={rndLogoInstance} className={styles.hsrc__logo} alt="hsrc logo" /></Link>
              </li>
              <li><a href="/">Home</a></li>
              <li><a href="/about">The R&D Survey</a></li>
              <li><a href="/research">R&D Research</a></li>
              <li><a href="/faq">FAQ</a></li>
              <li><a target="_blank" href="https://hsrc.ac.za/divisions/centre-for-science-technology-and-innovation-indicators/" rel="noopener noreferrer" >Innovation Surveys</a></li>
              <li className="buttons">
                <Link to='/expressinterest'>
                  <button className="button">Express Interest</button>
                </Link>
                <Link to='/login'>
                  <button className="button__orange">Log In</button>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </BrowserView>
      <MobileView>
        {mobileNavigationBar()}
      </MobileView>
    </>
  );
}
export default NavigationBar;